"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRowActions = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_2 = require("@nextui-org/react");
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var routes_1 = require("../../../../../../constants/routes");
var main_1 = require("../../../../../../reducers/slices/main");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var permissions_1 = __importDefault(require("../../../../../../hooks/permissions"));
var IUser_1 = require("../../../../../../interfaces/IUser");
var branch_1 = require("../../../../../../reducers/slices/branch/branch");
var constants_1 = require("../constants");
var toggle_branch_status_thunk_1 = require("../../../../../../reducers/slices/branch/thunks/updates/toggle_branch_status_thunk");
var doshx_controls_web_1 = require("doshx_controls_web");
var delete_branch_1 = require("../../../../../../api/calls/branch/delete/delete_branch");
var constants_2 = require("../../../../../../constants/constants");
var branch_list_thunk_1 = require("../../../../../../reducers/slices/branch/thunks/get/branch_list_thunk");
var useRowActions = function () {
    var navigate = (0, react_router_dom_1.useNavigate)();
    var dispatch = (0, react_redux_1.useDispatch)();
    var _a = (0, react_redux_1.useSelector)(function (state) { return state.branchState; }), pagination = _a.pagination, branches = _a.branches, selectedBranchiesIDs = _a.selectedBranchiesIDs;
    var query = {};
    var branchesPermissions = (0, permissions_1.default)(IUser_1.IPermissions.BRANCHES);
    var _getBranchList = function (params) {
        if (params === void 0) { params = {}; }
        return dispatch((0, branch_list_thunk_1.branch_list_thunk)(__assign(__assign(__assign({}, pagination), query), params)));
    };
    var onSelectionChange = function (keys) {
        if (keys === "all") {
            dispatch((0, branch_1.setSelectedBranchiesIDs)(keys));
            return;
        }
        var resultKeys = new Set(keys);
        var currentKeys = selectedBranchiesIDs === "all" ? new Set(branches.map(function (item) { return String(item._id); })) : selectedBranchiesIDs;
        currentKeys.forEach(function (key) {
            if (!branches.some(function (item) { return String(item._id) === key; })) {
                resultKeys.add(key);
            }
        });
        dispatch((0, branch_1.setSelectedBranchiesIDs)(resultKeys));
    };
    var rowActions = function (cellValue) {
        return [
            branchesPermissions.canView && {
                element: ((0, jsx_runtime_1.jsx)(react_2.Tooltip, __assign({ className: "text-foreground", content: "View" }, { children: (0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { onClick: function () {
                            dispatch((0, branch_1.setSelectedBranch)(constants_1.initialBranchData));
                            navigate("".concat(routes_1.CONSOLE_ROUTE).concat(routes_1.BRANCHES_ROUTE).concat(routes_1.BRANCH_DETAILS_ROUTE, "/").concat(cellValue === null || cellValue === void 0 ? void 0 : cellValue._id));
                        }, className: "cursor-pointer text-default-400", height: 18, icon: pro_solid_svg_icons_1.faEdit, width: 18 }) }))),
                key: "view",
            },
            branchesPermissions.canUpdate && {
                element: ((0, jsx_runtime_1.jsx)(react_2.Tooltip, __assign({ className: "text-foreground", content: "Status" }, { children: (0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { onClick: function () {
                            dispatch((0, toggle_branch_status_thunk_1.toggle_branch_status_thunk)({
                                branch_id: cellValue === null || cellValue === void 0 ? void 0 : cellValue._id,
                                branch_status: !(cellValue === null || cellValue === void 0 ? void 0 : cellValue.offline),
                            }));
                        }, className: "cursor-pointer text-default-400", height: 18, icon: pro_solid_svg_icons_1.faCheck, width: 18 }) }))),
                key: "status",
            },
            branchesPermissions.canDelete && {
                element: ((0, jsx_runtime_1.jsx)(react_2.Tooltip, __assign({ className: "text-foreground", content: "Delete" }, { children: (0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { onClick: function () { return onDeleteBranch(cellValue); }, className: "cursor-pointer text-default-400", height: 18, icon: pro_solid_svg_icons_1.faTrash, width: 18 }) }))),
                key: "delete",
            },
        ].filter(Boolean);
    };
    console.log("rowActions ===> ", rowActions({ _id: "123", display_name: "Test Branch" }));
    var onDeleteBranch = function (data) {
        dispatch((0, main_1.setContentModal)({
            title: "Confirm",
            content: ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "flex pt-4 gap-4" }, { children: [(0, jsx_runtime_1.jsx)(doshx_controls_web_1.LabelControl, { label: "Are you sure you want to delete this branch ".concat(data.display_name, "?"), textColor: "text-inputText" }), (0, jsx_runtime_1.jsx)(doshx_controls_web_1.ButtonControl, { label: "Cancel", size: "small", backgroundColor: "bg-slate-300", textColor: "text-dark", onClick: function () { return dispatch((0, main_1.setContentModal)(null)); } }), (0, jsx_runtime_1.jsx)(doshx_controls_web_1.ButtonControl, { label: "Continue", size: "small", onClick: function () { return _deleteBranch(data); } })] }))),
        }));
    };
    var _deleteBranch = function (data) {
        (0, delete_branch_1.branch_delete)({ _id: data._id }).then(function (response) {
            if (response.success) {
                dispatch((0, main_1.setContentModal)(null));
                _getBranchList();
            }
            else {
                dispatch((0, main_1.setMessageModal)({ title: constants_2.REQUEST_ERROR_TITLE, messages: [response.message] }));
            }
        });
    };
    return (0, react_1.useMemo)(function () { return ({ rowActions: rowActions, onSelectionChange: onSelectionChange }); }, [rowActions]);
};
exports.useRowActions = useRowActions;
